import React from 'react';

interface IButtonProps extends React.ComponentProps<'button'> {
  children: React.ReactNode;
  variant?: 'primary' | 'clear';
}

export const Button: React.FC<IButtonProps> = ({
  children,
  variant = 'primary',
  ...props
}) => {
  return (
    <span
      className={`tw-lf-button tw-ml-4 tw-h-10 tw-w-10 tw-rounded-full
      tw-p-0 tw-grid-area-[button] group-hover:tw-cursor-pointer
      ${
        variant === 'primary'
          ? 'tw-lf-button-primary group-hover:tw-bg-yellow-400'
          : 'tw-lf-button-ghost'
      }`}
      {...props}
    >
      {children}
    </span>
  );
};
